<div class="side-nav" sideNav>
    <ul class="ant-menu ant-menu-root ant-menu-inline side-nav-menu" [ngClass]="{
            'ant-menu-inline-collapsed': isFolded,
            'ant-menu-dark' : isSideNavDark
        }">
        <li [ngClass]="item.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'"
            *ngFor="let item of menuItems"
            [routerLinkActive]="item.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
            [routerLinkActiveOptions]="{exact: true}">
          
            <a [routerLink]="item.path" class="ant-menu-parent" *ngIf="!item?.submenu?.length; else hasChild">
                <nz-icon nzTheme="outline" *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" />
                <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
                <img *ngIf="item.iconType == ''" [src]="item.src" alt="">
                <span>{{item.title}}</span>
            </a>
            <ng-template #hasChild>
                <a href="javascript:void(0);" (click)="item.selected = !item.selected" class="ant-menu-parent ant-menu-submenu-title"
                    *ngIf="item.submenu.length > 0">
                    <nz-icon nzTheme="outline" *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" />
                    <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
                    <img *ngIf="item.iconType == ''" [src]="item.src" alt="">
                    <span>{{item.title}}</span>
                    <i class="ant-menu-submenu-arrow"></i>
                </a>
                <!-- Second Level -->
                <ul class="ant-menu ant-menu-inline ant-menu-sub ant-dropdown-menu" *ngIf="item.submenu.length > 0"
                    [ngClass]="item.selected ? 'open-menu' : ''">
                    <li [ngClass]="subItem.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline  p-l-15' : 'ant-menu-item'"
                        *ngFor="let subItem of item.submenu"
                        [routerLinkActive]="subItem.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
                        [routerLinkActiveOptions]="{exact: true}">
                    
                        <a [routerLink]="subItem.path" class="" *ngIf="!subItem?.submenu?.length; else hasChildren">
                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                                <circle cx="1" cy="1" r="1" fill="#828282" />
                                <circle cx="5" cy="1" r="1" fill="#828282" />
                                <circle cx="1" cy="5" r="1" fill="#828282" />
                                <circle cx="5" cy="5" r="1" fill="#828282" />
                                <circle cx="1" cy="9" r="1" fill="#828282" />
                                <circle cx="5" cy="9" r="1" fill="#828282" />
                            </svg>
                            <span style="margin-left: 5px;">{{subItem.title}}</span>
                        </a>
                        <ng-template #hasChildren>
                            <a href="javascript:void(0);" (click)="item.subMenuSelected = !item.subMenuSelected" class="ant-menu-submenu-title" *ngIf="subItem.submenu.length > 0">
                                <span>{{subItem.title}}</span>
                                <i class="ant-menu-submenu-arrow"></i>
                            </a>
                            <!-- Third Level -->
                            <ul class="ant-menu ant-menu-inline ant-menu-sub ant-dropdown-menu"
                            *ngIf="subItem.submenu.length > 0" [ngClass]="item.subMenuSelected ? 'open-menu' : ''">
                            <li [ngClass]="subItem.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'"
                                *ngFor="let subItem of subItem.submenu" routerLinkActive="ant-menu-item-selected"
                                [routerLinkActiveOptions]="{exact: true}">
                                <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-15"
                                    *ngIf="subItem.submenu.length > 0">
                                    <nz-icon nzTheme="outline" *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" />
                                    <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10"
                                        [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                                    <span>{{subItem.title}}</span>
                                    <i class="ant-menu-submenu-arrow"></i>
                                </a>
                                <a [routerLink]="subItem.path" class="p-l-15" *ngIf="!(subItem.submenu.length > 0)">
                                    <nz-icon nzTheme="outline" *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" />
                                    <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10"
                                        [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                                    <span>{{subItem.title}}</span>
                                </a>
                            </li>
                        </ul>
                        </ng-template>
                     
                    </li>
                </ul>
            </ng-template>

          
        </li>
    </ul>
</div>